module.exports = __webpack_public_path__ + "img/station-day.67a76d89.png";